import { render, staticRenderFns } from "./TableQuestionLayout.vue?vue&type=template&id=715c1ded&scoped=true"
import script from "./TableQuestionLayout.vue?vue&type=script&lang=js"
export * from "./TableQuestionLayout.vue?vue&type=script&lang=js"
import style0 from "./TableQuestionLayout.vue?vue&type=style&index=0&id=715c1ded&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715c1ded",
  null
  
)

export default component.exports